module.exports = __webpack_public_path__ + "static/media/outlet.c001223d.svg";